import { listHubs, listStaff } from '../../api';
import { attentionItems } from '../../lib/attention';

export const FLEET_LOADED = 'FLEET_LOADED';
export const FLEET_CLEAR = 'FLEET_CLEAR';
export const ATTENTION_DISMISS = 'ATTENTION_DISMISS';

/**
 * Fetch hubs and staff (with their badges) into the store. What needs
 * attention is derived from them, and the header shows it on every page.
 * Resolves once both have loaded; rejects with the first failure, having
 * stored whichever did load.
 */
export const loadFleet = (dispatch) => Promise.all([
  listHubs().then((hubs) => dispatch({ type: FLEET_LOADED, hubs })),
  listStaff().then((staff) => dispatch({ type: FLEET_LOADED, staff }))
]);

/** Forget the fleet, on signing out. */
export const clearFleet = () => ({ type: FLEET_CLEAR });

/** Hide one attention item until what it is about changes. */
export const dismissAttention = (id) => ({ type: ATTENTION_DISMISS, id });

// Derived once per change to the fleet or the dismissed set, not per render.
let cache = { hubs: undefined, staff: undefined, dismissed: undefined, signature: undefined, items: [] };

/** The attention items still showing, worst first. */
export const selectAttention = (state) => {
  const { hubs, staff, dismissed } = state.fleet;
  const items = attentionItems({ hubs, staff });
  // The threshold can change between polls without the fleet changing, so
  // the titles are part of the cache key.
  const signature = items.map((item) => item.id + item.title).join('|');
  if (cache.hubs !== hubs || cache.staff !== staff || cache.dismissed !== dismissed || cache.signature !== signature) {
    cache = { hubs, staff, dismissed, signature, items: items.filter((item) => !dismissed[item.id]) };
  }
  return cache.items;
};
